<!-- src/components/AlcoholEducation.vue -->
<template>
  <div class="alcohol-education mt-[240px]">
    <section class="banner">
      <img src="../assets/alcohol.jpg" alt="Recovery Center" />
    </section>
    <header>
      <h1>Understanding Alcoholism</h1>
      <p>Learn about the effects of alcoholism, its risks, and how to seek help.</p>
    </header>

    <section class="section">
      <h2>What is Alcoholism?</h2>
      <p>
        Alcoholism, also known as alcohol use disorder, is a chronic disease characterized by
        an inability to control or stop drinking despite adverse consequences. It can impact
        physical, mental, and emotional health and often disrupts relationships, work, and daily
        life.
      </p>
    </section>

    <section class="section">
      <h2>Signs and Symptoms of Alcoholism</h2>
      <ul>
        <li>Inability to limit alcohol consumption</li>
        <li>Experiencing strong cravings for alcohol</li>
        <li>Neglecting responsibilities due to drinking</li>
        <li>Developing a tolerance to alcohol</li>
        <li>Experiencing withdrawal symptoms when not drinking</li>
      </ul>
    </section>

    <section class="section">
      <h2>Effects of Alcohol on Health</h2>
      <p>
        Alcoholism can have severe effects on the body, including liver disease, heart problems,
        and mental health disorders. Prolonged alcohol abuse increases the risk of developing
        cancers, weakens the immune system, and can lead to memory loss and emotional instability.
      </p>
    </section>

    <section class="section">
      <h2>How to Seek Help</h2>
      <p>
        Recovery from alcoholism often begins with a commitment to change. Seeking professional
        help, joining support groups, and following a structured treatment plan can significantly
        improve one’s journey to recovery. Reach out to rehabilitation centers, counselors, or
        trusted health professionals to begin the process.
      </p>
    </section>

    <footer class="footer">
      <p>If you or someone you know is struggling with alcoholism, don’t hesitate to seek help. Recovery is possible.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'AlcoholEducation'
};
</script>

<style scoped>
.alcohol-education {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  padding: 20px;
  max-width: 800px;
  margin: auto;
}

header {
  text-align: center;
  margin-bottom: 20px;
}

.banner {
  padding: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.banner img {
  width: 100%;
  max-width: 700px;
  border-radius: 8px;
}

h1 {
  color: #2c3e50;
}

.section {
  margin-bottom: 20px;
}

.section h2 {
  color: #2c3e50;
  font-size: 1.5em;
  margin-top: 10px;
}

ul {
  list-style-type: disc;
  margin-left: 20px;
}

.footer {
  margin-top: 20px;
  text-align: center;
  font-weight: bold;
  color: #555;
}
</style>
